import React from "react";

class PaymentFailed extends React.Component {
  render() {
    return (
      <div style={{ padding: 80, textAlign: "center" }}>
        <h1>✅ Payment Failed</h1>
        <p>Your booking is failed.</p>
      </div>
    );
  }
}

export default PaymentFailed;
